import React from 'react';
const Recovered = () => {
    return (
        <div>
            <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88.29 81.35" class="h-12 py-1 m-auto"><path fill="#276749" d="M72.31,9.32c-12.4,0-19.9,8.3-22.4,11.06C47.4,18,37.24,9.43,27.54,9.43c-10.66,0-21.69,8.93-21.69,23.88C5.85,48,21.17,62,32.36,72.3L50,90.68,67.56,72.41C78.78,62.12,94.14,48,94.14,33.31,94.14,19,85.37,9.32,72.31,9.32Zm-4,47.5H57v11H42.62v-11h-11V42.44h11V31.14H57v11.3H68.3V56.82Z" transform="translate(-5.85 -9.32)"></path></svg>
        </div>
    );
}

export default Recovered;